import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
// SharedModule removed to avoid circular dependency in demo
import { VivaScoreGuageComponent } from './viva-score-guage.component';

@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    
  ],
  declarations: [VivaScoreGuageComponent],
  exports: [VivaScoreGuageComponent],
})
export class VivaScoreGuageModule {}


